import { useNavigate } from "react-router-dom";

export const AuthTabs = ({ active }) => {
  const navigate = useNavigate();
  return (
    <div
      role="tablist"
      data-testid="auth-tabs"
      className="grid grid-cols-2 mt-6 mb-8 border-b border-white/10"
    >
      <button
        role="tab"
        data-testid="tab-login"
        aria-selected={active === "login"}
        onClick={() => navigate("/login")}
        className={`pb-3 text-lg font-bold tracking-wide transition-colors ${
          active === "login" ? "text-white" : "text-white/55 hover:text-white/80"
        }`}
      >
        Log in
        <span
          className={`block h-[3px] mt-3 rounded-full transition-all ${
            active === "login" ? "bg-[#19a55c]" : "bg-white/10"
          }`}
        />
      </button>
      <button
        role="tab"
        data-testid="tab-signup"
        aria-selected={active === "signup"}
        onClick={() => navigate("/register")}
        className={`pb-3 text-lg font-bold tracking-wide transition-colors ${
          active === "signup" ? "text-white" : "text-white/55 hover:text-white/80"
        }`}
      >
        Sign up
        <span
          className={`block h-[3px] mt-3 rounded-full transition-all ${
            active === "signup" ? "bg-[#19a55c]" : "bg-white/10"
          }`}
        />
      </button>
    </div>
  );
};
